var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.value,
        title: _vm.title,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        "show-close": _vm.showClose,
        "append-to-body": "",
        width: "1020px"
      }
    },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 20 } },
        [
          _c("el-col", [
            _c("video", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isTakingPhoto,
                  expression: "!isTakingPhoto"
                }
              ],
              ref: "videoRef",
              attrs: { width: "640", height: "480", autoplay: "", muted: "" },
              domProps: { muted: true }
            }),
            _vm._v(" "),
            _c("canvas", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isTakingPhoto,
                  expression: "isTakingPhoto"
                }
              ],
              ref: "canvasRef",
              staticStyle: { width: "640px", height: "480px" },
              attrs: { width: "640", height: "480" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px", "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isTakingPhoto,
                        expression: "!isTakingPhoto"
                      }
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.handleTakePhoto }
                  },
                  [_vm._v("\n          拍照\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isTakingPhoto,
                        expression: "isTakingPhoto"
                      }
                    ],
                    attrs: { type: "danger" },
                    on: { click: _vm.handleRetakePhoto }
                  },
                  [_vm._v("\n          重拍\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isTakingPhoto,
                        expression: "isTakingPhoto"
                      }
                    ],
                    attrs: { type: "success" },
                    on: { click: _vm.handleSavePhoto }
                  },
                  [_vm._v("\n          完成\n        ")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    "file-list": _vm.fileList,
                    action: _vm.action,
                    data: _vm.uploadData,
                    limit: _vm.limit,
                    "before-upload": _vm.handleBeforeUpload,
                    "on-exceed": _vm.handleExceed,
                    "on-change": _vm.handleChange,
                    "on-remove": _vm.handleRemove,
                    "on-success": _vm.handleSuccess,
                    "on-error": _vm.handleError,
                    accept: _vm.accept,
                    "list-type": "picture-card",
                    multiple: "",
                    "with-credentials":
                      !_vm.accept.includes("jpg") &&
                      !_vm.accept.includes("mp4") &&
                      _vm.action.indexOf("yishou-img") === -1
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "file",
                      fn: function(ref) {
                        var file = ref.file
                        return _c("div", { staticClass: "image-view" }, [
                          _c("img", {
                            staticClass: "el-upload-list__item-thumbnail",
                            attrs: { src: file.url, alt: "" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "el-upload-list__item-actions" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-preview",
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePreview(file)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-zoom-in" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-delete",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemove(file)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-delete" })]
                              )
                            ]
                          )
                        ])
                      }
                    }
                  ])
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus",
                    attrs: { slot: "default" },
                    slot: "default"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.isShowCloseBtn
            ? _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(" 关闭 ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.isDisabled,
                loading: _vm.isUploading,
                type: "primary"
              },
              on: { click: _vm.handleConfirm }
            },
            [_vm._v("\n      保存\n    ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0462b95e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0462b95e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YsComponents/YsCamera.vue
// module id = null
// module chunks = 